import { Trans, useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { Box } from '@bridebook/ui';
import {
  DATE_FORMAT,
  format,
} from '@bridebook/web/lib/time-date-manipulation/time-date-manipulation';
import { getDateFnsLocale } from '@bridebook/web/lib/i18n/utils/get-date-fns-format';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useRsvpData } from '../guest-rsvp.context';
import componentStyles from './header.style';
import { getThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';

const GuestRsvpHeader: React.FC = () => {
  const { weddingWebsite, weddingRsvp, theme } = useRsvpData();
  const { t } = useTranslation('weddingWebsite');
  const market = useMarket();

  const themeProperties = useMemo(() => getThemeProperties(theme), [theme]);
  const styles = componentStyles(themeProperties);

  const partners = weddingWebsite.wedding.partners;

  const formattedDeadline = useMemo(() => {
    if (weddingRsvp?.deadline) {
      return format(new Date(weddingRsvp.deadline.seconds * 1000), DATE_FORMAT.DATE.SHORT, {
        locale: getDateFnsLocale(market.locale),
      });
    }
    return '';
  }, [weddingRsvp?.deadline, market.locale]);

  return (
    <Box style={styles.wrapper}>
      <Box as="h1" style={styles.title}>
        <Trans ns="weddingWebsite" i18nKey="rsvp.guestForm.headerTitle" values={{ partners }}>
          {'{{partners.0}}'} & {'{{partners.1, possessive}}'} <br />
          wedding
        </Trans>
      </Box>
      {weddingRsvp?.deadline && (
        <Box as="h2" style={styles.subtitle}>
          {t('rsvp.guestForm.deadlineInformation', {
            deadline: formattedDeadline,
          })}
        </Box>
      )}
    </Box>
  );
};

export default GuestRsvpHeader;
